var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M8.466 9.332c0-.101.035-.2.1-.277l4.586-5.421a.429.429 0 0 0-.327-.705H2.075a.429.429 0 0 0-.327.705l4.584 5.421a.43.43 0 0 1 .102.277v4.781c0 .319.335.526.62.383l1.175-.587a.43.43 0 0 0 .237-.383z"
  })));
};
export default SvgFilter;